import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/dist/alpha.esm.js';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => {
      const { SignInPage } = await import('@backstage/core-components');
      const { gitlabAuthApiRef } = await import('@backstage/core-plugin-api');
      return props => (
        <SignInPage
          {...props}
          auto
          provider={{
            id: 'gitlab-auth-provider',
            title: 'GitLab',
            message: 'Prihlas sa cez GitLab',
            apiRef: gitlabAuthApiRef,
          }}
        />
      );
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    kubernetesPlugin,
    grafanaPlugin,
    gitlabPlugin,
    techdocsPlugin,
    navModule,
    homeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
